import React from "react";
import Layout from "../components/Layout";
import ReunionDetails from "../components/Manager/ReunionDetails"; 

function ReunionDetail() { 
  return (
    <Layout>
      <div className="p-6">
        <ReunionDetails />
      </div>
    </Layout>
  );
}

export default ReunionDetail;
